import { FC } from "react";
import { getVersionDisplayText } from "../../utils/version";
import { VersionDisplay } from "@libs/zapi-ui/custom";

export const AppFooter: FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-gray-50/50 mt-auto">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center text-[14px] text-gray-600">
          <div>© {new Date().getFullYear()} Innovera Admin</div>
          <div className="flex items-center gap-2">
            <span>Version:</span>
            <VersionDisplay version={getVersionDisplayText()} />
          </div>
        </div>
      </div>
    </footer>
  );
};
